import{a as n}from"./chunk-SEOPWYQE.js";import t from"react";var a=({element:o,classProps:e})=>o?t.createElement(n,{element:o,classProps:e}):null;export{a};
